import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/newsfeed/ArticleSearch/ArticleSearchSkeleton/articleSearchSkeleton.consts';
import { Wrapper } from '@web/newsfeed/Article/ArticleComments/ArticleComment/articleComment.styles';

export const ArticleCommentSkeleton = () => {
  return (
    <Wrapper>
      <ContentLoader height={40} viewBox="0 0 300 40" {...DEFAULT_SETTINGS}>
        <circle cx="16" cy="16" r="16" />
        <rect x="42" y="5" rx="0" ry="0" width="100" height="10" />
        <rect x="42" y="17" rx="0" ry="0" width="230" height="10" />
        <rect x="42" y="29" rx="0" ry="0" width="160" height="10" />
      </ContentLoader>
    </Wrapper>
  );
};
